export default __webpack_public_path__ + "static/bandwidth-3-bac39eb97f70d452227351f53e130475.png";